import { initializeApp, FirebaseApp } from 'firebase/app';
import { initializeAuth, Auth, indexedDBLocalPersistence } from 'firebase/auth';
import { getStorage, FirebaseStorage } from 'firebase/storage';
import { getFunctions, Functions } from 'firebase/functions';
import { environment } from '../../environments/environment';

let app: FirebaseApp;
let auth: Auth;
let storage: FirebaseStorage;
let functions: Functions;

export const getFirebaseApp = () => {
  if (!app) {
    app = initializeApp(environment.firebase);
  }
  return app;
}

export const getFirebaseAuth = () => {
  if (!auth) {
    auth = initializeAuth(getFirebaseApp(), { persistence: indexedDBLocalPersistence });
  }
  return auth;
}

export const getFirebaseStorage = () => {
  if (!storage) {
    storage = getStorage(getFirebaseApp());
  }
  return storage;
}

export const getFirebaseFunctions = () => {
  if (!functions) {
    functions = getFunctions(getFirebaseApp(), 'southamerica-east1');
  }
  return functions;
}
